var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.partnerProxyId)?_c('cp-postbox-list',{attrs:{"partner-proxy-id":_vm.partnerProxyId}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }